<div class="flex items-center" [class]="containerClass()">
    <!-- Monthly Option -->
    <label class="flex items-center cursor-pointer" [class]="optionClass()">
    <span 
        class="rounded-full border-[1.5px] flex items-center justify-center bg-white"
        [class]="radioSizeClass()"
        [class.border-gray-400]="value() !== 'monthly'"
        [class.border-gray-800]="value() === 'monthly'"
        (click)="selectPeriod('monthly')">
        @if (value() === 'monthly') {
        <span class="rounded-full bg-gray-800" [class]="dotSizeClass()"></span>
        }
    </span>
    <span 
        class="text-sm"
        [class.text-gray-400]="value() !== 'monthly'"
        [class.text-gray-800]="value() === 'monthly'"
        [class.font-semibold]="value() === 'monthly'"
        (click)="selectPeriod('monthly')">
        {{ monthlyLabel() }}
    </span>
    </label>
    
    <!-- Yearly Option with Badge -->
    <label class="flex items-center cursor-pointer" [class]="optionClass()">
    <span 
        class="rounded-full border-[1.5px] flex items-center justify-center bg-white"
        [class]="radioSizeClass()"
        [class.border-gray-400]="value() !== 'yearly'"
        [class.border-gray-800]="value() === 'yearly'"
        (click)="selectPeriod('yearly')">
        @if (value() === 'yearly') {
        <span class="rounded-full bg-gray-800" [class]="dotSizeClass()"></span>
        }
    </span>
    <div class="flex items-center gap-2" (click)="selectPeriod('yearly')">
        <span 
        class="text-sm"
        [class.text-gray-400]="value() !== 'yearly'"
        [class.text-gray-800]="value() === 'yearly'"
        [class.font-semibold]="value() === 'yearly'">
        {{ yearlyLabel() }}
        </span>
        @if (showSavingsBadge()) {
        <span class="px-2 py-1 bg-brand-orange-100 text-brand-orange-600 text-xs font-medium rounded">
            {{ savingsText() }}
        </span>
        }
    </div>
    </label>
</div>